import { Candidate } from './../../model/candidate';
import { SidebarService } from './../../service/sidebar.service';
import { CandidateService } from './../../service/candidate.service';
import { Component, OnInit, ViewChild, AfterViewInit, ElementRef, QueryList, ViewChildren  } from '@angular/core';
import { SessionService } from '../../service/session.service';
import { Constants } from '../../constant';
import { CandidateModel } from '../../model/candidate';
import { Contest } from '../../model/contest';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from "@angular/platform-browser";
import 'rxjs/add/observable/forkJoin'
import { AccessibilityService } from '../../service/accessibility.service';
import { AuthService } from '../../service/auth.service';

@Component({
  selector: 'app-votingpage',
  templateUrl: './votingpage.component.html',
  styleUrls: ['./votingpage.component.scss']
})
export class VotingpageComponent implements OnInit, AfterViewInit {

  readonly CONSTANTS = Constants;
  error: string;
  candidates: CandidateModel[];
  pageIndex: number;
  totalCompleted: number = 0;
  blackout: boolean;
  mobile: boolean;
  @ViewChildren('landtitle') landtitle: QueryList<ElementRef>;
  constructor(private sessionService: SessionService,
    private activeRoute: ActivatedRoute,
    private accessibilityService: AccessibilityService,
    private router: Router,
    private authService: AuthService,
    private titleService: Title) {
    this.candidates = [];
    this.pageIndex = 0
    this.totalCompleted = 0;
    this.titleService.setTitle("Online Ballot Voting Page");
  }

  ngOnInit() {
    this.getCandidateList();
    this.activeRoute.queryParams.subscribe(params => {
      if (params) {
        this.pageIndex = params['pageIndex'] !== undefined ? params['pageIndex'] : 0;
      }
    });
    if (window.innerWidth < 825) { 
      this.mobile = true;
    }
    this.blackout = this.accessibilityService.current.blackout;
    
  }
  ngAfterViewInit() {
    this.focusSettings();
  }

  focusSettings() {
    this.landtitle.changes.subscribe(() => {
      setTimeout(() => this.setFocus(this.landtitle.toArray()[0]), 0);
      this.titleService.setTitle(this.landtitle.toArray()[0].nativeElement.innerHTML + '- 2026 CAPE Contract Ratification');
    })
  }

  private getCandidateList() {
    this.sessionService.getSessionValue(this.CONSTANTS.CANDIDATE_KEY).subscribe((response: any) => {
      var candidatesObj = JSON.parse(response['value']);
      if (candidatesObj !== null) {
        this.candidates = candidatesObj;
      }
    },
      error => {
        this.authService._sessionTimeout = true;
        this.authService.logout();
        this.router.navigate(['/#']);
      });
  }



  prevPosition() {

    this.pageIndex--;
    this.setCandidateSession();

  }

  nextPosition() {
    this.totalCompleted = 1;
    this.pageIndex++;
    this.setCandidateSession();
  }

  onChangeCandidates(candidate, index) {

    if (candidate.target.checked) {
      this.candidates[index]['SelectionCount']++;
    } else {
      this.candidates[index]['SelectionCount']--;
    }

    this.setCandidateSession();
  }

  setCandidateSession() {
    this.sessionService.putSessionValue(this.CONSTANTS.CANDIDATE_KEY, JSON.stringify(this.candidates));
  }

  voteSummary() {

    if (this.candidates.length > this.totalCompleted) {
      this.totalCompleted++;
    }

    this.setCandidateSession();
    this.router.navigate(['/ballot-review']);
  }

  viewCandidateStatement(candidate: Candidate) {
    // this.candidate = candidate;
    // this.viewPage = this.CONSTANTS.CANDIDATE_STATEMENT_PAGE;
    this.router.navigate(['/candidate-statement', candidate.CandidateId])
  }
  gotoSettings() {
    this.router.navigate(['/settings']);
  }
  setFocus(landtitle: ElementRef) {
    landtitle && landtitle.nativeElement.focus();
    landtitle.nativeElement.scrollIntoView();
  }
}



// WEBPACK FOOTER //
// ./src/app/features/votingpage/votingpage.component.ts